import { jsxs as r, jsx as e, Fragment as i } from "react/jsx-runtime";
import { Text as U, withDatasourceCheck as S } from "@sitecore-jss/sitecore-jss-nextjs";
import { i as j, P as s } from "../../chunks/page-content.B0ugSU6N.js";
import { useState as B, useEffect as P } from "react";
import { useRouter as C } from "next/router";
import { useI18n as o } from "next-localization";
import { u as k } from "../../chunks/use-is-auth-token-generated.BkMrw8To.js";
import { NeuFeedback as D, NeuSelect as p, NeuTable as u, NeuPagination as I } from "@hcahealthcaredpx/neutron-react";
import { useQuery as tt } from "@tanstack/react-query";
import { S as et, q as ct } from "../../chunks/stale.constant.De1PuSBj.js";
import { a as dt } from "../../chunks/api.DHdhNbok.js";
import { saveTimestampToLocalStorage as at } from "../../utils/storage/index.js";
import { u as rt } from "../../chunks/use-get-activity-logs.CtJNiFeY.js";
import { S as mt, B as ht } from "../../chunks/screen-reader-announcement.CfQ0eanj.js";
import { c as yt } from "../../chunks/capitalize-first-letter.CXZ9Rvhq.js";
const vt = async (t) => {
  at();
  const c = "api/support-console/sc-activity-logs", a = new URLSearchParams(t).toString(), m = await dt.get(`${c}?${a}`);
  if (!m.ok)
    throw new Error(await m.json());
  return m.json();
}, bt = ({
  queryParams: t,
  enabled: c = !0
}) => tt({
  queryKey: ct.scActivityLog(t),
  queryFn: () => vt(t),
  staleTime: et,
  refetchOnWindowFocus: !1,
  enabled: c
}), l = ({ address: t }) => t ? /* @__PURE__ */ r(i, { children: [
  t.addressLine1 || "",
  t.addressLine2 && /* @__PURE__ */ e("div", { children: t.addressLine2 }),
  t.city && /* @__PURE__ */ r("div", { children: [
    t.city,
    ", ",
    t.state
  ] }),
  t.zipcode && /* @__PURE__ */ e("div", { children: t.zipcode })
] }) : null, ut = ({ linkingDetailsPatientInfo: t, linkingDetailsUserProfile: c }) => {
  const { t: a } = o();
  return /* @__PURE__ */ r("div", { children: [
    /* @__PURE__ */ e("p", { className: "mb-2 mt-2", children: /* @__PURE__ */ r("b", { children: [
      a("MHO.SupportConsole.ActivityLog.ClinicalInformation"),
      ":"
    ] }) }),
    /* @__PURE__ */ r("dl", { children: [
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("MHO.SupportConsole.UserSearch.SearchResults.Name"),
        ":"
      ] }) }),
      /* @__PURE__ */ r("dd", { children: [
        t == null ? void 0 : t.firstName,
        " ",
        t == null ? void 0 : t.lastName
      ] }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("MHO.SupportConsole.ActivityLog.MRN"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: (t == null ? void 0 : t.mrn) || "" }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("Mho.PageContent.RecordsLinking.Form.Labels.Gender"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: (t == null ? void 0 : t.gender) || "" }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("Mho.PageContent.RecordsLinking.Form.Labels.DateOfBirth"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: (t == null ? void 0 : t.dob) || "" }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("MHO.SupportConsole.UserSearch.SearchResults.Phone"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: (t == null ? void 0 : t.phoneNumber) || "" }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("Mho.PageContent.RecordsLinking.Form.Labels.Address"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: /* @__PURE__ */ e(l, { address: t == null ? void 0 : t.address }) })
    ] }),
    /* @__PURE__ */ e("br", {}),
    /* @__PURE__ */ e("p", { className: "mb-2 mt-2", children: /* @__PURE__ */ r("b", { children: [
      a("MHO.SupportConsole.ActivityLog.ProfileInformation"),
      ":"
    ] }) }),
    /* @__PURE__ */ r("dl", { children: [
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("MHO.SupportConsole.UserSearch.SearchResults.Name"),
        ":"
      ] }) }),
      /* @__PURE__ */ r("dd", { children: [
        c == null ? void 0 : c.firstName,
        " ",
        c == null ? void 0 : c.lastName
      ] }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("Mho.PageContent.RecordsLinking.Form.Labels.Gender"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: c == null ? void 0 : c.gender }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("Mho.PageContent.RecordsLinking.Form.Labels.DateOfBirth"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: c == null ? void 0 : c.dob }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("MHO.SupportConsole.UserSearch.SearchResults.Phone"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: c == null ? void 0 : c.phoneNumber }),
      /* @__PURE__ */ e("dt", { children: /* @__PURE__ */ r("b", { children: [
        a("Mho.PageContent.RecordsLinking.Form.Labels.Address"),
        ":"
      ] }) }),
      /* @__PURE__ */ e("dd", { children: /* @__PURE__ */ e(l, { address: c == null ? void 0 : c.address }) })
    ] })
  ] });
}, Nt = (t) => t.activityType === "Transmitted" && t.transmitEmail ? `Transmitted to ${t.transmitEmail}` : t.activityType;
function Lt(t, c) {
  return t ? t.map((a) => {
    var O, y, A, $, R;
    const m = a, b = a;
    let v = null;
    if (!j((O = b.patientLinkingActivity) == null ? void 0 : O.details))
      try {
        v = JSON.parse(
          (y = b.patientLinkingActivity) == null ? void 0 : y.details
        ).userLinkageInfo;
      } catch (M) {
        v = null, console.error("Error parsing patient linking activity JSON:", M);
      }
    const w = v == null ? void 0 : v.patientInfo, L = v == null ? void 0 : v.userProfile, G = c && /* @__PURE__ */ r(i, { children: [
      b.activity,
      j(v) ? "" : /* @__PURE__ */ r(i, { children: [
        /* @__PURE__ */ e("br", {}),
        /* @__PURE__ */ e(
          ut,
          {
            linkingDetailsPatientInfo: w,
            linkingDetailsUserProfile: L
          }
        )
      ] })
    ] }), z = c ? ($ = (A = b.patientLinkingActivity) == null ? void 0 : A.activity) == null ? void 0 : $.actorId : m == null ? void 0 : m.actorId, J = c ? z || a.myHealthOneId || null : a.myHealthOneId || null, T = c ? b.name : `${m.firstName ?? ""} ${m.lastName ?? ""}`.trim(), K = c ? G : Nt(m), F = c ? b.date || "" : m.activityTime ? new Date(m.activityTime).toLocaleDateString() : "", V = c ? b.time || "" : m.activityTime ? new Date(m.activityTime).toLocaleTimeString() : "", E = c && ((b == null ? void 0 : b.activityRationale) || ((R = b.patientLinkingActivity) == null ? void 0 : R.mismatchReason)) || "";
    return {
      myHealthOneId: J,
      name: T,
      activity: K,
      date: F,
      time: V,
      comments: E
    };
  }) : [];
}
const Tt = (t, c, a) => ({
  fromNumber: (t - 1) * c + 1,
  toNumber: Math.min(t * c, a),
  totalRecordsCount: a
}), At = ({
  isInSupportConsole: t,
  tableRows: c,
  tableRowsCountOptions: a
}) => {
  var _, g, X;
  const { t: m } = o(), b = C(), [v, w] = B(1), [L, G] = B(15), [z, J] = B(""), [T, K] = B({
    sortType: t != null && t.value ? "Date" : "activityTime",
    sortDirection: "desc"
  }), F = t != null && t.value && b.query.user || "", V = k(), E = rt({
    queryParams: {
      sortBy: T.sortType,
      sortDirection: T.sortDirection,
      resultsPerPage: L.toString(),
      pageIndex: v.toString(),
      timeZoneOffset: "0"
      // activityTime is already in UTC, no need to pass timeZoneOffset calcs
    },
    enabled: !(t != null && t.value)
  }), O = bt({
    queryParams: {
      SortCriteria: T.sortType,
      MyHealthOneId: F,
      SortOrder: T.sortDirection === "asc" ? "Ascending" : "Descending",
      PageLimit: L.toString(),
      PageIndex: v.toString(),
      // multiplied by -1 because getTimezoneOffset() returns the difference
      // as (UTC - LOCAL TIME). To get the intuitive offset from UTC and show it on the UI, we need
      // to invert it to (LOCAL TIME - UTC).
      TimeZoneOffset: ((/* @__PURE__ */ new Date()).getTimezoneOffset() * -1).toString()
    },
    enabled: t != null && t.value ? !j(F) && V : !1
  }), y = t != null && t.value ? O.data : E.data, A = t != null && t.value ? O.isPending : E.isPending, $ = [
    "MHO Id",
    "Name",
    "Activity",
    "Date",
    "Time",
    ...t != null && t.value ? ["Comments"] : []
  ], R = new Map($.map((d, h) => [d, h])), M = [...c].sort(
    (d, h) => (R.get(d.displayName) ?? 0) - (R.get(h.displayName) ?? 0)
  ), Z = {
    Activity: t != null && t.value ? "Activity" : "activityType",
    Date: t != null && t.value ? "Date" : "activityTime"
  };
  let q = [];
  t != null && t.value && (y != null && y.data) && "result" in y.data ? q = y.data.result ?? [] : y != null && y.data && "activityLogEvents" in y.data && (q = y.data.activityLogEvents ?? []);
  const Q = Lt(q, t == null ? void 0 : t.value), H = ((_ = y == null ? void 0 : y.meta) == null ? void 0 : _.totalCount) || 0, f = a.map((d) => {
    var h, N;
    return {
      value: (h = d.fields.optionLabel) == null ? void 0 : h.value,
      label: (N = d.fields.optionLabel) == null ? void 0 : N.value
    };
  }).sort((d, h) => Number(d.value) - Number(h.value)), W = a.find((d) => {
    var h, N;
    return (N = (h = d.fields) == null ? void 0 : h.isDefault) == null ? void 0 : N.value;
  });
  return P(() => {
    !A && H > 0 && J(
      m("MHO.Accessibility.ViewingRecords", {
        ...Tt(v, L, H)
      })
    );
  }, [m, A, v, L, H]), A ? /* @__PURE__ */ e(D, { kind: "spinner", className: "px-6 py-4" }) : /* @__PURE__ */ r(i, { children: [
    /* @__PURE__ */ e(mt, { announcement: z }),
    (t == null ? void 0 : t.value) && /* @__PURE__ */ e(ht, {}),
    /* @__PURE__ */ e(
      p,
      {
        items: f,
        label: m("Mho.PageContent.ActivityLog.ResultsPerPage"),
        className: "w-100 w-md-25 float-end mb-3",
        placeholder: m("Mho.PageContent.ActivityLog.Select"),
        required: !0,
        defaultValue: (X = (g = W == null ? void 0 : W.fields) == null ? void 0 : g.optionLabel) == null ? void 0 : X.value,
        onNeuChange: (d) => {
          G(Number(d.value)), w(1);
        },
        value: { value: L.toString(), label: L.toString() }
      }
    ),
    /* @__PURE__ */ r("div", { className: "mb-4", children: [
      !A && !j(q) && /* @__PURE__ */ r(
        u,
        {
          caption: "Activity log table",
          onNeuSort: ({ column: d, direction: h }) => {
            var n, Y;
            const N = ((Y = (n = d == null ? void 0 : d.props) == null ? void 0 : n.field) == null ? void 0 : Y.value) || d, x = h === "asc" ? "asc" : "desc";
            K({
              sortType: t != null && t.value ? Z[yt(N)] || "Activity" : Z[N] || "activityType",
              sortDirection: x
            });
          },
          children: [
            /* @__PURE__ */ e(u.Header, { children: /* @__PURE__ */ e(u.Row, { children: M == null ? void 0 : M.map((d, h) => {
              var N, x, n;
              return /* @__PURE__ */ e(
                u.Column,
                {
                  header: !0,
                  sort: (x = (N = d.fields) == null ? void 0 : N.isSortable) == null ? void 0 : x.value,
                  direction: Z[d.displayName] === T.sortType ? T.sortDirection : "none",
                  children: /* @__PURE__ */ e(U, { field: (n = d.fields) == null ? void 0 : n.columnTitle })
                },
                `${d.id}}-${h}`
              );
            }) }) }),
            /* @__PURE__ */ e(u.Content, { children: Q == null ? void 0 : Q.map((d, h) => /* @__PURE__ */ r(u.Row, { children: [
              /* @__PURE__ */ e(u.Column, { style: { width: "15%" }, children: d.myHealthOneId }),
              /* @__PURE__ */ e(u.Column, { style: { width: "20%" }, children: d.name }),
              /* @__PURE__ */ e(u.Column, { style: { width: "25%" }, children: d.activity }),
              /* @__PURE__ */ e(u.Column, { style: { width: "15%" }, children: d.date }),
              /* @__PURE__ */ e(u.Column, { style: { width: "15%" }, children: d.time }),
              (t == null ? void 0 : t.value) && /* @__PURE__ */ e(u.Column, { style: { width: "10%" }, children: d.comments })
            ] }, `${d.activity}-${h}`)) })
          ]
        }
      ),
      H > L && /* @__PURE__ */ e("div", { className: "d-flex justify-content-center mt-3", children: /* @__PURE__ */ e(
        I,
        {
          color: "blue",
          current: v,
          kind: "paginator",
          onNeuChange: (d) => w(d == null ? void 0 : d.value),
          results: H,
          limit: L
        }
      ) })
    ] })
  ] });
}, Ot = ({
  fields: t,
  rendering: c
}) => /* @__PURE__ */ e(s, { "data-test-id": c == null ? void 0 : c.componentName, children: /* @__PURE__ */ e(s.NodeContent, { children: /* @__PURE__ */ e(
  At,
  {
    isInSupportConsole: t == null ? void 0 : t.isInSupportConsole,
    tableRows: t == null ? void 0 : t.tableRows,
    tableRowsCountOptions: t == null ? void 0 : t.tableRowsCountOptions
  }
) }) }), Jt = S()(Ot);
export {
  Jt as ActivityLog
};
